import { createContext, useContext, useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import { jwtDecode } from 'jwt-decode';
import { hasPermission as checkPermission } from '../permissions/permissions';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

const checkTokenValidity = () => {
  const token = localStorage.getItem('token');
  if (!token) return logout();

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;
    if (decoded.exp < now) {
      console.warn('Token expiré');
      return logout();
    }

    // seulement après vérification
    setUser(decoded);
  } catch (err) {
    console.warn('Token corrompu');
    logout();
  }
};



  const fetchUser = async () => {
    const token = localStorage.getItem('token');
     if (!token) {
      setLoading(false);
      return null;
    }
       try {
      const res = await axios.get('/api/auth/profile', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      let nextUser = res.data.user;
      try {
        const permissionRes = await axios.get('/api/permissions/me', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        nextUser = {
          ...nextUser,
          role: permissionRes.data.role || nextUser.role,
          permissions: permissionRes.data.permissions || [],
          permissionViews: permissionRes.data.views || [],
          permissionActions: permissionRes.data.actions || [],
        };
      } catch (permissionError) {
        console.warn('Permissions indisponibles', permissionError);
      }
      setUser(nextUser);
      return nextUser; 
    } catch (err) {
      console.warn('Token invalide ou expiré');
      localStorage.removeItem('token');
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchUser();
     const interval = setInterval(() => {
      checkTokenValidity();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);

  }, []);

  // const login = async (email, password) => {
  //   console.log("test")
  //   const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, { email, password });
  //   console.log(res)
    
  //   localStorage.setItem('token', res.data.token);
  //   return await fetchUser();
  //   // setUser(res.data.user);
  //    await fetchUser();
  // };

  const login = async (email, password) => {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, { email, password });
    localStorage.setItem('token', res.data.token);

    // fetchUser renvoie le user après l’avoir mis dans le state
    const fetchedUser = await fetchUser();
    
    if (fetchedUser) {
      localStorage.setItem("user", JSON.stringify(fetchedUser));
    }

    return fetchedUser;
};


  return (
    <AuthContext.Provider value={{ user, loading, login, logout, fetchUser, hasPermission: (permissionKey) => checkPermission(user, permissionKey) }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
